<script setup lang="ts">
// Remplace le bouton de redirection quand l'application est installée (PWA) :
// un lien ouvert de là ne mène pas au navigateur, l'utilisateur copie donc
// l'adresse et la colle lui-même dans son navigateur.
import { ref } from "vue";
import { useTranslation } from "i18next-vue";
import DRBtn from "@/components/UI/DRBtn.vue";

const props = defineProps<{ url: string }>();
const emit = defineEmits<{ (e: "copied"): void }>();

const { t } = useTranslation();

const COPIED_FEEDBACK_MS = 2500;
const copied = ref(false);

const copy = async () => {
  try {
    await navigator.clipboard.writeText(props.url);
  } catch {
    // Presse-papiers refusé : l'adresse reste lisible dans la consigne.
    return;
  }
  copied.value = true;
  emit("copied");
  setTimeout(() => (copied.value = false), COPIED_FEEDBACK_MS);
};
</script>

<template>
  <DRBtn
    :icon="copied ? 'bi-check-lg' : 'bi-copy'"
    :label="copied ? t('brandMigration.copied') : t('brandMigration.copy')"
    variant="primary"
    @click="copy"
  />
</template>
